<template>
  <div
    class="phone"
    ref="phone"
  >
    <a
      type="primary"
      @click="showModal"
    >
      编辑地址
    </a>
    <a-modal
      title="编辑地址"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      cancel-text="取消"
      ok-text="确定"
      :get-container="()=>$refs.phone"
    >
      <!-- 地址 -->
      <a-spin
        :spinning="spinAddress"
      >
        <div>
          <!-- <div
            style="display: flex;
            align-items: center;
            margin-bottom: 20px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >所在地区</span>
            <a-cascader
              :options="options"
              placeholder=""
              @change="onChange"
              style="width: 200px;
              background: #FFFFFF;
              border-radius: 3px;"
            />
          </div> -->
          <div
            style="display: flex;
            align-items: center;
            margin-bottom: 64px;
            position: relative;"
          >
            <span
              style="width: 80px;
              text-align: right;
              margin-right: 14px;"
            >详细地址</span><a-textarea
              v-model="newLocation"
              placeholder="输入详细地址"
              style="width: 330px;
              background: #FFFFFF;
              border: 1px solid #EAEAEA;
              border-radius: 3px;"
            />
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { CHINA_REGION } from '@/utils/chinaRegionArray.js';
import { location } from '@/api/user/user.js';
export default {
  name: 'PhoneNumber',
  data() {
    return {
      newLocation: '',
      visible: false, // 弹窗显示
      confirmLoading: false, // 按钮加载
      spinAddress: false, // 加载
      options: CHINA_REGION,
    };
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    handleOk() {
      this.spinAddress = true;
      this.confirmLoading = true;
      location({ locationNew: this.newLocation }).then(res => {
        if (res.data.status === 'SUCCESS') {
          this.visible = false;
          this.spinAddress = false;
          this.confirmLoading = false;
          this.$message.success('编辑地址成功！');
          this.$parent.$parent.info();
        } else {
          this.spinAddress = false;
          this.confirmLoading = false;
          this.$message.warning(res.data.errorMsg);
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.phone {
  /deep/ .ant-modal-header {
    border: none;
  }
  /deep/ .ant-modal-footer {
    border: none;
    height: 76px;
    background-color: #F7FAFF;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px;
  }
  /deep/ .ant-spin-container {
    padding-top: 40px;
    border-top: 1px solid #EBF2F7;
  }
  /deep/ .ant-btn {
    width: 100px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #007CE2;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #007CE2;
  }
  /deep/ .ant-btn-primary {
    background: #007CE2;
    color: #fff;
    margin-right: 14px;
    margin-left: 20px;
  }
}
</style>
